<template>
    <div
        class="search-main"
    >
        <div class="searching-block">
            <input
                ref="input"
                class="searching-input"
                placeholder="Поиск по сайту"
                v-model="search"
            >

            <CloseIcon
                class="close-icon"
                @click.stop="closeHandler"
            />
        </div>
        <transition name="content-transition">
            <div v-if="showContent" class="content">
                <div class="searching-switcher" @click="showCategoriesHandler">
                    <div class="searching-switcher-label">
                        Выбрать раздел
                    </div>
                    <div class="searching-switcher-arrow" :class="{ open: showCategories }" />
                </div>
                <SearchResults
                    :show-categories="showCategories"
                    :search="search"
                    @change="changeCategoriesHandler"
                    @clear="clearSearchHandler"
                    @navigate="closeHandler(true)"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import CloseIcon from "../../assets/images/icons/close.svg?inline";
import SearchResults from "./SearchResults";
import {mapActions, mapGetters} from "vuex";

const getters = [
    'isMobile',
    'searchReceived',
];

const actions = [
    'searchText',
    'clearSearch',
];

export default {
    name: "MobileHeaderSearch",

    components: {
        SearchResults,
        CloseIcon,
    },

    data() {
        return {
            search: '',
            showCategories: false,
            activeCategories: [],
        };
    },

    mounted() {
        this.$nextTick(() => {
            const input = this.$refs.input;
            input && input.focus();
        });
    },

    computed: {
        ...mapGetters(getters),

        showContent() {
            return this.searchReceived;
        },
    },

    watch: {
        search(value) {
            this.searchHandler(value);
        },

        isMobile() {
            this.closeHandler();
        },
    },

    methods: {
        ...mapActions(actions),

        searchHandler(str) {
            const value = str !== undefined ? str : this.search;

            if (!value || value.length < 3) {
                this.clearSearch();
                return;
            }

            this.searchText({ str: value, filters: this.getFilters() });
        },

        getFilters() {
            let filterString = '';
            if (this.activeCategories) {
                this.activeCategories.forEach(el => {
                    filterString += `&filter[index][]=${ el }`;
                });
            }
            return filterString;
        },

        changeCategoriesHandler(items) {
            this.activeCategories = items;
            this.searchHandler();
        },

        showCategoriesHandler() {
            this.showCategories = !this.showCategories;
        },

        closeHandler(forceClose = false) {
            this.showCategories = false;
            this.clearSearchHandler();
            this.$emit('close');
            if (forceClose === true) {
                this.$emit('navigate');
            }
        },

        clearSearchHandler() {
            this.search = '';
            this.activeCategories = [];
            this.clearSearch();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../styles/rem";

.content-transition-enter-active, .content-transition-leave-active {
  transition: opacity .1s;
}
.content-transition-enter, .content-transition-leave-to /* .content-transition-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
.close-icon {
    color: #98A0A9;
    width: mrem(22);
    height: mrem(22);
}

.search {
    &-button {
        width: rem(32);
        height: rem(32);
        border-radius: rem(32);
        // background: #A4C4FF url('~assets/images/UI/search-white.svg') no-repeat center/50%;
        margin: 0 auto;
        position: relative;
        top: rem(12);
        cursor: pointer;

        @include on-md {
            width: mdrem(32);
            height: mdrem(32);
            border-radius: mrem(32);
            top: mdrem(12);
        }

        @include on-mobile {
            width: mrem(32);
            height: mrem(32);
            border-radius: mrem(32);
            top: mrem(12);
        }
    }

    &-main {
        font-family: 'Proxima Nova', sans-serif;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        z-index: 1000;
        background: rgba(255, 255, 255, 0.15);
    }
}

.searching {
    &-block {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        background-color: #FFFFFF;
        width: 100%;
        height: rem(56);
        padding: 0 rem(24);

        @include on-md {
            height: mdrem(56);
            padding: 0 mdrem(24);
        }

        @include on-mobile {
            height: mrem(56);
            padding: 0 mrem(24);
        }
    }

    &-input {
        flex: 1 1 auto;
        margin-right: rem(16);
        border: none;
        outline: none;
        font-family: 'Proxima Nova', sans-serif;
        font-size: rem(18);
        line-height: rem(26);
        color: #2A2626;

        &::placeholder {
            color: #98A0A9;
        }

        @include on-md {
            margin-right: mdrem(16);
            font-size: mdrem(18);
            line-height: mdrem(26);
        }

        @include on-mobile {
            margin-right: mrem(16);
            font-size: mrem(18);
            line-height: mrem(26);
        }
    }

    &-switcher {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: rem(16);
        cursor: pointer;

        @include on-md {
            margin-bottom: mdrem(16);
        }

        @include on-mobile {
            margin-bottom: mrem(16);
        }
    }

    &-switcher-label {
        font-weight: 600;
        font-size: rem(16);
        line-height: rem(24);
        color: #4663AB;

        &:hover {
            color: #356ED5;
        }

        @include on-md {
            font-size: mdrem(16);
            line-height: mdrem(24);
        }

        @include on-mobile {
            font-size: mrem(16);
            line-height: mrem(24);
        }
    }

    &-switcher-arrow {
        width: rem(12);
        height: rem(6);
        margin-left: rem(10);
        background: url("../../assets/images/icons/down-arrow-blue.svg") no-repeat center/contain;
        transition: trasform 200ms;

        &.open {
            transform: rotate(180deg);
            transition: trasform 200ms;
        }

        @include on-md {
            width: mdrem(12);
            height: mdrem(6);
            margin-left: mdrem(10);
        }

        @include on-mobile {
            width: mrem(12);
            height: mrem(6);
            margin-left: mrem(10);
        }
    }

    &-back-button {
        width: rem(10);
        height: rem(16);
        margin-right: rem(15);
        background: url("../../assets/images/icons/back-arrow-blue.svg") no-repeat center/contain;
        cursor: pointer;

        @include on-md {
            width: mdrem(10);
            height: mdrem(16);
            margin-right: mdrem(15);
        }

        @include on-mobile {
            width: mrem(10);
            height: mrem(16);
            margin-right: mrem(15);
        }
    }
}

.content {
    @include custom-scroll-bar;
    height: auto;
    overflow-y: scroll;
    padding: rem(16) rem(16) rem(24);
    border-top: 1px solid #D2D5D9;
    background-color: #FFFFFF;

    @include on-md {
        padding: mdrem(16) mdrem(16) mdrem(24);
    }

    @include on-mobile {
        position: absolute;
        top: mrem(56);
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1001;
        height: 100vh;
        padding: mrem(16) mrem(16) mrem(24);
    }
}
</style>
